import { slokaAudioUrl, meaningAudioUrl } from './mediaUrls';
import { DEFAULT_LANGUAGE } from './defaultLanguage';

export const PLAYBACK_MODES = [
  { id: 'sloka', label: 'Verse recitation only' },
  { id: 'meaning', label: 'Meaning only' },
  { id: 'both', label: 'Verse then meaning' }
];

export const REPEAT_MODES = [
  { id: 'none', label: 'Stop at end' },
  { id: 'all', label: 'Loop all 18 chapters' }
];

export function buildPlaybackQueue(slokas, options) {
  const {
    mode = 'sloka',
    language = DEFAULT_LANGUAGE,
    voice = 'male',
    startChapter = 1,
    endChapter = 18
  } = options;

  const filtered = slokas
    .filter(
      (s) =>
        s.language === language &&
        s.chapterNumber >= startChapter &&
        s.chapterNumber <= endChapter
    )
    .sort((a, b) => {
      if (a.chapterNumber !== b.chapterNumber) {
        return a.chapterNumber - b.chapterNumber;
      }
      return a.slokaNumber - b.slokaNumber;
    });

  const queue = [];

  filtered.forEach((sloka) => {
    const base = {
      chapterNumber: sloka.chapterNumber,
      slokaNumber: sloka.slokaNumber,
      speaker: sloka.speaker,
      slokaText: sloka.sloka,
      meaningText: sloka.meaning
    };

    if (mode === 'sloka' || mode === 'both') {
      queue.push({
        ...base,
        id: `${sloka.chapterNumber}-${sloka.slokaNumber}-sloka`,
        type: 'sloka',
        label: `Chapter ${sloka.chapterNumber} · Verse ${sloka.slokaNumber} · Recitation`,
        src: slokaAudioUrl(sloka.chapterNumber, sloka.slokaNumber, voice)
      });
    }
    if (mode === 'meaning' || mode === 'both') {
      queue.push({
        ...base,
        id: `${sloka.chapterNumber}-${sloka.slokaNumber}-meaning`,
        type: 'meaning',
        label: `Chapter ${sloka.chapterNumber} · Verse ${sloka.slokaNumber} · Meaning`,
        src: meaningAudioUrl(language, sloka.chapterNumber, sloka.slokaNumber)
      });
    }
  });

  return queue;
}

/** Distinct chapter numbers in queue order (respects start/end chapter range). */
export function getChaptersInQueue(queue) {
  const chapters = [];
  queue.forEach((track) => {
    if (!chapters.includes(track.chapterNumber)) {
      chapters.push(track.chapterNumber);
    }
  });
  return chapters;
}

export function findChapterStartIndex(queue, chapterNumber) {
  return queue.findIndex((track) => track.chapterNumber === chapterNumber);
}

/** Returns adjacent chapter number, or null if none in that direction. */
export function getAdjacentChapterInQueue(queue, currentChapter, direction) {
  const chapters = getChaptersInQueue(queue);
  const index = chapters.indexOf(currentChapter);
  if (index === -1) return null;

  const nextIndex = index + direction;
  if (nextIndex < 0 || nextIndex >= chapters.length) return null;
  return chapters[nextIndex];
}
